import { useInfiniteQuery } from '@tanstack/react-query';
import { axiosInt } from 'library';

import type { IPaginatedNotifications } from '../../utils/notificationTypes';
import { NOTIFICATIONS_KEY, NOTIFICATIONS_URL } from './notificationsConstants';
import useNotificationOrgId from './useNotificationOrgId';

export const NOTIFICATIONS_PAGE_SIZE = 10;

export const fetchNotificationsApi = async (
  params?: Record<string, unknown>
): Promise<IPaginatedNotifications> =>
  (await axiosInt.get(NOTIFICATIONS_URL, { params })).data;

const useFetchInfiniteNotifications = (unreadOnly: boolean) => {
  const orgId = useNotificationOrgId();

  const {
    data,
    isLoading: isLoadingNotifications,
    error: errorFetchingNotifications,
    fetchNextPage: fetchNextNotifications,
    hasNextPage: hasNextNotifications,
    isFetchingNextPage: isFetchingNextNotifications,
  } = useInfiniteQuery<IPaginatedNotifications>({
    queryKey: [NOTIFICATIONS_KEY, orgId, 'list', 'infinite', unreadOnly],
    queryFn: ({ pageParam }) =>
      fetchNotificationsApi({
        page: pageParam,
        size: NOTIFICATIONS_PAGE_SIZE,
        ...(unreadOnly && { read: false }),
      }),
    initialPageParam: 1,
    getNextPageParam: ({ meta }) =>
      meta.page < meta.pages ? meta.page + 1 : undefined,
    enabled: Boolean(orgId),
  });

  return {
    notifications: data?.pages.flatMap(page => page.data) ?? [],
    isLoadingNotifications,
    errorFetchingNotifications,
    fetchNextNotifications,
    hasNextNotifications,
    isFetchingNextNotifications,
  };
};

export default useFetchInfiniteNotifications;
